// viewport-level UI events
export const VIEWPORT_MOUSEDOWN = "VIEWPORT_MOUSEDOWN";
export const VIEWPORT_MOUSTUP = "VIEWPORT_MOUSEUP";

export const VIEWPORT_ZOOM = "VIEWPORT_ZOOM";
export const VIEWPORT_CLICK = "VIEWPORT_CLICK";

export const SELECT_ENTITIES = "SELECT_ENTITIES";
export const DESELECT_ENTITIES = "DESELECT_ENTITIES";
export const MODIFY_ENTITIES = "MODIFY_ENTITIES";

// editor state
export const SELECT_TOOL = "SELECT_TOOL";
export const DESELECT_TOOL = "DESELECT_TOOL";

export const TOOL_BEGIN = "TOOL_BEGIN";
export const TOOL_OPTIONS_UPDATE = "TOOL_OPTIONS_UPDATE";
export const TOOL_RESULT_UPDATE = "TOOL_UPDATE";
export const TOOL_COMPLETE = "TOOL_COMPLETE";

export const TOOLTIP_DRAG = "TOOLTIP_DRAG";
export const DELETE_ENTITIES = "DELETE_STUFF";
export const ADD_ENTITIES = "ADD_ENTITIES";

// incomplete scene updates (like tool transformations)
export const UPDATE_PENDING_ENTITIES = "UPDATE_PENDING_ENTITIES";
export const APPLY_PENDING_ENTITY_UPDATES = "APPLY_PENDING_ENTITY_UPDATES ";

// transform tool lifecycle
export const TRANSFORM_TOOLTIP_DRAG_START = "TRANSFORM_TOOLTIP_DRAG_START";
export const TRANSFORM_TOOLTIP_DRAG = "TRANSFORM_TOOLTIP_DRAG";
export const TRANSFORM_TOOLTIP_DRAG_COMPLETE = "TRANSFORM_TOOLTIP_DRAG_COMPLETE";

export const OPEN_OPTIONS_DIALOG = "OPEN_OPTIONS_DIALOG";
export const CLOSE_OPTIONS_DIALOG = "CLOSE_OPTIONS_DIALOG";

export const OPEN_HOTKEY_INFO_DIALOG = "OPEN_HOTKEY_INFO_DIALOG";
export const CLOSE_HOTKEY_INFO_DIALOG = "CLOSE_HOTKEY_INFO_DIALOG";

export const SET_NEW_BOUNDARY_TYPE = "SET_NEW_BOUNDARY_TYPE";
export const SET_NEW_OBJECT_TYPE = "SET_NEW_OBJECT_TYPE";

export const COPY_ENTITIES = "COPY_ENTITIES";
export const PASTE_ENTITIES = "PASTE_ENTITIES";

export const SET_FLOOR_SCALE = "SET_FLOOR_SCALE";

// units
export const SET_UNITS = "SET_UNITS";
export const IMPERIAL_FEET_INCHES = "IMPERIAL_FEET_INCHES";
export const IMPERIAL_INCHES = "IMPERIAL_INCHES";
export const METRIC = "METRIC";
export const IMPERIAL_METRIC_MULTIPLIER = 2.54; // in to cm
export const IMPERIAL_SUFFIX = "in";
export const METRIC_SUFFIX = "cm";

export const CALCULATE_REGIONS = "CALCULATE_REGIONS";
export const DISCARD_REGIONS = "DISCARD_REGIONS";

export const APPLY_COLOR_SCHEME = "APPLY_COLOR_SCHEME";
export const SET_SNAPPING_ENABLED = "SET_SNAPPING_ENABLED";
